import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useState } from "react";
import { DateTime } from "luxon";
import { dateToMinutes, minutesToDate, percentageToMinutes } from "./timePickerUtils";
export interface DragConfig {
  dayStartMinutes: number;
  totalRange: number;
  baseDate: DateTime;
  startMinutes: number;
  endMinutes: number;
}
export const useSliderDrag = () => {
  const $ = _c(7);
  const trackRef = useRef(null);
  const draftStartRef = useRef(null);
  const draftEndRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      dayStartMinutes: 0,
      totalRange: 0,
      baseDate: DateTime.now(),
      startMinutes: 0,
      endMinutes: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const dragConfigRef = useRef(t0);
  const [draftStart, _setDraftStart] = useState(null);
  const [draftEnd, _setDraftEnd] = useState(null);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = d => {
      draftStartRef.current = d;
      _setDraftStart(d);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setDraftStart = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = d_0 => {
      draftEndRef.current = d_0;
      _setDraftEnd(d_0);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setDraftEnd = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = thumb => e => {
      e.preventDefault();
      const target = e.currentTarget as HTMLElement;
      target.setPointerCapture(e.pointerId);
      const onMove = moveEvent => {
        const {
          dayStartMinutes,
          totalRange,
          baseDate,
          startMinutes,
          endMinutes
        } = dragConfigRef.current;
        const track = trackRef.current;
        if (!track) {
          return;
        }
        const rect = track.getBoundingClientRect();
        const pct = Math.max(0, Math.min(1, (moveEvent.clientX - rect.left) / rect.width));
        const mins = percentageToMinutes(pct, dayStartMinutes, totalRange);
        if (thumb === "start") {
          const currentEnd = draftEndRef.current ? dateToMinutes(draftEndRef.current) : endMinutes;
          const clamped = Math.min(mins, currentEnd);
          setDraftStart(minutesToDate(baseDate, clamped));
        } else {
          const currentStart = draftStartRef.current ? dateToMinutes(draftStartRef.current) : startMinutes;
          const clamped_0 = Math.max(mins, currentStart);
          setDraftEnd(minutesToDate(baseDate, clamped_0));
        }
      };
      const cleanup = () => {
        target.removeEventListener("pointermove", onMove);
        target.removeEventListener("pointerup", cleanup);
        target.removeEventListener("pointercancel", cleanup);
      };
      target.addEventListener("pointermove", onMove);
      target.addEventListener("pointerup", cleanup);
      target.addEventListener("pointercancel", cleanup);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleThumbPointerDown = t3;
  let t4;
  if ($[4] !== draftEnd || $[5] !== draftStart) {
    t4 = {
      trackRef,
      draftStart,
      draftEnd,
      setDraftStart,
      setDraftEnd,
      dragConfigRef,
      handleThumbPointerDown
    };
    $[4] = draftEnd;
    $[5] = draftStart;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};